export class NativeStreamProbeIssue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowIndex",
            "baseName": "rowIndex",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamProbeIssue.attributeTypeMap;
    }
    constructor() {
    }
}
